module.exports = __webpack_public_path__ + "img/logo-header.5dd54a30.png";